<template>
    <div id="FlowData">
        <HrrBreadcrumb PMname="其他功能" CMname="流路数据管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="站点名称：">
                        <el-select v-model="searchform.siteId" placeholder="请选择" filterable >
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备编号：">
                        <el-input v-model="searchform.deviceNickCode" >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="流路类型：" prop="mtypeCode">
                        <el-select v-model="searchform.mTypeCode" placeholder="请选择"  >
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in mTypeData" :key="item.mtypeCode" :label="item.mtypeName" :value="item.mtypeCode">
                            </el-option>
                        </el-select>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间段：">
                        <el-date-picker v-model="searchform.beginPostTime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"  ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="至">
                        <el-date-picker v-model="searchform.endPostTime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"  ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="导出：">
                        <el-select v-model="searchform.isExport" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange" border stripe style="width: 100%" v-loading="loading">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="160" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="160" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="siteName" label="所属站点" >
                    </el-table-column>
                    <el-table-column prop="postTime" label="上传时间" width="160">
                    </el-table-column>
                    <el-table-column prop="mTypeCode" label="流路编码" width="140">
                    </el-table-column>
                    <el-table-column prop="mTypeName" label="流路" width="140">
                    </el-table-column>
                    <el-table-column prop="mTypeUnit" label="单位" width="100">
                    </el-table-column>              
                    <el-table-column prop="value" label="值" width="80">
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="160">
                    </el-table-column>
                    <el-table-column label="是否导出" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.isExport?'success':'danger'" disable-transitions>{{scope.row.isExport?'是':'否'}}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
    </div>
</template>
<script>
export default {
    name: 'Flow_Data',
    data() {
        return {
            searchform: {
                pageNum: 1,
                pageSize: 10,
                siteId: "",
                deviceNickCode: "",
                mTypeCode: "",
                beginPostTime: "",
                endPostTime: "",
                isExport: ""
            },
            siteidData: [],
            tableData: [],
            mTypeData: [],
            total: 0,
            loading: true,
            selectionRows: [],
            SiteId2: [],
            isFormLightbox: true
        }
    },
    methods: {
        onSubmit() {
            this.searchform.pageNum = 1;
            this.$route.meta.FlowData = this.searchform;
            this.initData();
        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.initData();
        },
        Rowview(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/alert/config/view/' + val.aConfigId });
        },
        RowEdit(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/alert/config/edit/' + val.aConfigId });
        },
        Rowdelete(val) {
            this.$confirm("确定要删除 '" + val.alertName + "' 此记录么？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios({
                            method: "delete",
                            url: this.$api.AlertConfig.api + "/" + val.aConfigId
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        RowUser(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/alert/configuser/' + val.aConfigId, });
        },
        Addclick() {
            this.$router.push({ path: '/alert/config/add/', });
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        editclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
            if (this.selectionRows.length > 1) {
                this.$message({ message: "只能操作一行数据", type: "warning" });
                return;
            }
            this.$route.meta.row = this.selectionRows[0];
            this.$router.push({ path: '/alert/config/edit/' + this.selectionRows[0].aConfigId });
        },
        delclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在删除", type: "warning" });
                return;
            }
            this.$confirm("确定要删除这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios({
                            method: "delete",
                            url: this.$api.AlertConfig.api + "/" + myrow.aConfigId
                        })
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.Success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {

                });
        },
        cellclick(row, column, cell, event) {
            this.$refs.Opentable.toggleRowSelection(row);
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.get(this.$api.MultiflowData.getData, { params: this.searchform })
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data.List;
                        Vuethis.total = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initParamsData() {
            var Vuethis = this;
            //site
            this.$hrraxios.get(this.$api.site.downlist)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.siteidData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
            //mtype
            this.$hrraxios.get(this.$api.AlertConfig.downlistmtype)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.mTypeData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        to.meta.FlowData = from.meta.FlowData;
        next();
    },
    created() {
        //功能管理
        this.$common.getFunListByMCode(this, "FlowData", () => {
            if (this.$route.meta.FlowData != undefined) {
                this.searchform = this.$route.meta.FlowData;
            }
            this.initData();
            this.initParamsData();
        });
    }
};
</script>
<style>
.input-with-select {
    width: 110px;
}

.educard label {
    color: #99a9bf;
}

.educard {
    margin-bottom: 10px;
}

.utable .el-button,
.utable .el-button+.el-button {
    margin-right: 10px;
    margin-left: 0;
}

#lightForm .el-select {
    width: 100px;
}
</style>